import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { FileStateInterface } from './types';
import { FileStatus } from './types';

export const initialState: FileStateInterface = {
  fileStatus: FileStatus.LOADING,
  fileHasBeenEdited: false,
};

const fileStateSlice = createSlice({
  name: 'fileState',
  initialState,
  reducers: {
    setFileStatus(state, action: PayloadAction<FileStatus>) {
      state.fileStatus = action.payload;
    },
    setFileHasBeenEdited(state, action: PayloadAction<boolean>) {
      state.fileHasBeenEdited = action.payload;
    },
    clearFileState() {
      return initialState;
    },
  },
});

export const { setFileStatus, setFileHasBeenEdited, clearFileState } =
  fileStateSlice.actions;

export const fileStateReducer = fileStateSlice.reducer;
